define("settings/models/ig-user", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _object.default.extend({
    accountType: null,
    bio: null,
    followsCount: 0,
    followedByCount: 0,
    fullName: null,
    isPlaceholderProfilePicture: false,
    mediaCount: 0,
    profilePictureUrl: null,
    socialProfile: null,
    username: null,
    website: null,
    secureProfilePictureUrl: (0, _object.computed)('profilePictureUrl', function () {
      if (this.profilePictureUrl) {
        return this.profilePictureUrl.replace('http://', 'https://');
      }

      return null;
    })
  });

  _exports.default = _default;
});